/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /**
   * Puffin Monogramming — Standalone Drawer Controller (Phase 1, patched)
   *
   * The theme's built-in Drawer JS class is instantiated per-section via the
   * `drawer` behavior registered only on the `header` section. Our monogram
   * drawer lives inside the `product` section which does NOT register the
   * `drawer` behavior, so no Drawer instance is ever created for it.
   *
   * This controller replicates the essential Drawer behavior (show/hide via
   * CSS classes, scroll lock events, focus trap, Escape key, underlay click)
   * directly, without depending on the theme's section-scoped instantiation.
   */
  function initMonogramTrigger() {
    var drawer = document.getElementById('drawer-monogram');
    if (!drawer) return;

    var toggleBtns = document.querySelectorAll('[data-drawer-toggle="drawer-monogram"]');
    var underlay = drawer.querySelector('[data-drawer-underlay]');
    var isOpen = false;

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      drawer.classList.remove('display-none');
      /* Allow a frame for display:none removal before adding visible class */
      setTimeout(function() {
        drawer.classList.add('drawer--visible');
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
        toggleBtns.forEach(function(btn) { btn.setAttribute('aria-expanded', 'true'); });
        /* Focus the first focusable element inside the drawer */
        var firstFocusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      }, 1);
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('drawer--visible');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      toggleBtns.forEach(function(btn) { btn.setAttribute('aria-expanded', 'false'); });
      /* Add display-none after CSS transition completes */
      setTimeout(function() {
        if (!drawer.classList.contains('drawer--visible')) {
          drawer.classList.add('display-none');
        }
      }, 800);
    }

    function toggleDrawer() {
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    }

    /* Bind all toggle buttons (both the CTA and the drawer close button) */
    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        toggleDrawer();
      });
    });

    /* Close on underlay click */
    if (underlay) {
      underlay.addEventListener('click', function() {
        closeDrawer();
      });
    }

    /* Close on Escape key */
    drawer.addEventListener('keyup', function(evt) {
      if (evt.key === 'Escape' || evt.which === 27) {
        closeDrawer();
        /* Return focus to the Personalize It button */
        var personalizeBtn = document.getElementById('puffin-cta--personalize');
        if (personalizeBtn) personalizeBtn.focus();
      }
    });

    /* Also listen for the theme:drawer:toggle event as a fallback */
    drawer.addEventListener('theme:drawer:toggle', function() {
      toggleDrawer();
    });
  }

  /**
   * Puffin Monogramming — Panel Controls State Controller (Phase 2)
   *
   * Manages:
   *   - Tab switching between Initials and Names panes
   *   - Design radio selection with dynamic maxlength enforcement
   *   - Text input formatting (uppercase initials, capitalized names)
   *   - Recommended thread color badge updates per design
   *   - Consent gate validation for the submit button
   */
  function initMonogramControls() {
    /* ── DOM references ── */
    var tabInitials   = document.getElementById('monogram-tab--initials');
    var tabNames      = document.getElementById('monogram-tab--names');
    var paneInitials  = document.getElementById('monogram-pane--initials');
    var paneNames     = document.getElementById('monogram-pane--names');
    var inputText     = document.getElementById('monogram-input--text');
    var inputName     = document.getElementById('monogram-input--name');
    var hintText      = document.getElementById('monogram-input--text-hint');
    var consentBox    = document.getElementById('monogram-checkbox--consent');
    var submitBtn       = document.getElementById('monogram-button--submit');
    var placementRadios = document.querySelectorAll('input[name="customizer-placement"]');
    var placementToggle = document.getElementById('monogram-placement-toggle');
    var placementWrapper = document.getElementById('monogram-placement-wrapper');
    var inputPlacement  = document.getElementById('monogram-input--placement');
    var hintBack        = document.getElementById('monogram-placement-hint--back');
    var hintDefault     = document.getElementById('monogram-placement-hint--default');
    var mockupBg        = document.getElementById('monogram-mockup-bg');
    var mockupOverlay   = document.querySelector('.monogram-drawer__mockup-overlay');

    /* Bail if Phase 2 elements are not present in the DOM */
    if (!tabInitials || !tabNames || !paneInitials || !paneNames) return;


    /* ── State ── */
    var activeTab = 'initials';  /* 'initials' | 'names' */
    var selectedDesign = null;

    /* ================================================================
       TAB SWITCHING
       ================================================================ */
    function switchTab(tab) {
      activeTab = tab;

      if (tab === 'initials') {
        tabInitials.classList.add('is-active');
        tabInitials.setAttribute('aria-selected', 'true');
        tabNames.classList.remove('is-active');
        tabNames.setAttribute('aria-selected', 'false');
        paneInitials.classList.add('is-active');
        paneInitials.removeAttribute('hidden');
        paneNames.classList.remove('is-active');
        paneNames.setAttribute('hidden', '');
      } else {
        tabNames.classList.add('is-active');
        tabNames.setAttribute('aria-selected', 'true');
        tabInitials.classList.remove('is-active');
        tabInitials.setAttribute('aria-selected', 'false');
        paneNames.classList.add('is-active');
        paneNames.removeAttribute('hidden');
        paneInitials.classList.remove('is-active');
        paneInitials.setAttribute('hidden', '');
      }

      /* Reset text inputs and placement */
      if (inputText) inputText.value = '';
      if (inputName) inputName.value = '';
      if (inputPlacement) inputPlacement.value = '';
      
      if (placementWrapper) placementWrapper.setAttribute('hidden', '');
      if (placementToggle) placementToggle.textContent = 'Need a custom spot?';
      if (placementRadios && placementRadios.length) {
        placementRadios[0].checked = true;
        for (var r = 0; r < placementRadios.length; r++) {
          placementRadios[r].dispatchEvent(new Event('change'));
        }
      }

      /* Deselect design radios from non-active pane */
      var inactivePane = tab === 'initials' ? paneNames : paneInitials;
      var activeRadios = inactivePane.querySelectorAll('input[name="customizer-design"]:checked');
      for (var i = 0; i < activeRadios.length; i++) {
        activeRadios[i].checked = false;
      }

      /* Auto-select first design of the active pane */
      var activePane = tab === 'initials' ? paneInitials : paneNames;
      var firstActiveRadio = activePane.querySelector('input[name="customizer-design"]');
      if (firstActiveRadio) {
        firstActiveRadio.checked = true;
        selectedDesign = firstActiveRadio.value;
      } else {
        selectedDesign = null;
      }

      updateAvailableColors(selectedDesign);
      validateForm();
      updateLivePreview();
    }

    tabInitials.addEventListener('click', function() { switchTab('initials'); });
    tabNames.addEventListener('click', function() { switchTab('names'); });

    /* ================================================================
       DESIGN SELECTION
       ================================================================ */
    var allDesignRadios = document.querySelectorAll('input[name="customizer-design"]');

    function updateAvailableColors(design) {
      var imageDef = window.PuffinMonogramImages ? window.PuffinMonogramImages[design] : null;

      var allowedColors = [];
      if (!imageDef || imageDef.mask) {
        allowedColors = Object.keys(colorHexMap);
      } else {
        allowedColors = Object.keys(imageDef);
      }

      var allSwatchLabels = document.querySelectorAll('.monogram-fieldset--colors .monogram-swatch__color-label');
      
      // Determine what color to auto-select
      var colorToSelect = null;
      if (allowedColors.indexOf('white') !== -1) {
        colorToSelect = 'white';
      }
      
      // Fallback to first allowed if white is not allowed
      if (!colorToSelect && allowedColors.length > 0) {
        colorToSelect = allowedColors[0];
      }

      for (var i = 0; i < allSwatchLabels.length; i++) {
        var radio = allSwatchLabels[i].querySelector('input');
        var handle = radio.getAttribute('data-thread-color');
        
        if (allowedColors.indexOf(handle) !== -1) {
          allSwatchLabels[i].style.display = '';
          if (handle === colorToSelect) {
            radio.checked = true;
          } else {
            radio.checked = false;
          }
        } else {
          allSwatchLabels[i].style.display = 'none';
          radio.checked = false;
        }
      }
    }

    function onDesignChange(e) {
      selectedDesign = e.target.value;
      var category = e.target.getAttribute('data-design-category');

      /* Enforce maxlength constraints */
      if (category === 'initials' && inputText) {
        if (selectedDesign === 'Set Sail') {
          inputText.setAttribute('maxlength', '1');
          /* Truncate existing value if longer than 1 */
          if (inputText.value.length > 1) {
            inputText.value = inputText.value.charAt(0);
          }
          if (hintText) {
            hintText.textContent = 'Exactly 1 character for Set Sail.';
          }
        } else {
          inputText.setAttribute('maxlength', '3');
          if (hintText) {
            hintText.textContent = 'Up to 3 characters. Letters only.';
          }
        }
      }

      updateAvailableColors(selectedDesign);
      validateForm();
      updateLivePreview();
    }

    for (var d = 0; d < allDesignRadios.length; d++) {
      allDesignRadios[d].addEventListener('change', onDesignChange);
    }


    /* ================================================================
       TEXT INPUT FORMATTING
       ================================================================ */
    if (inputText) {
      inputText.addEventListener('input', function() {
        /* Force uppercase for initials */
        var val = inputText.value.replace(/[^a-zA-Z]/g, '');
        inputText.value = val.toUpperCase();
        validateForm();
        updateLivePreview();
      });
    }

    if (inputName) {
      inputName.addEventListener('input', function() {
        /* Capitalize first letter, lowercase rest */
        var val = inputName.value.replace(/[^a-zA-Z]/g, '');
        if (val.length > 0) {
          inputName.value = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
        } else {
          inputName.value = '';
        }
        validateForm();
        updateLivePreview();
      });
    }

    /* ================================================================
       THREAD COLOR SELECTION — re-validate on change
       ================================================================ */
    var allThreadRadios = document.querySelectorAll('input[name="customizer-thread"]');
    for (var t = 0; t < allThreadRadios.length; t++) {
      allThreadRadios[t].addEventListener('change', function() {
        validateForm();
        updateLivePreview();
      });
    }

    /* ================================================================
       CONSENT GATE & FORM VALIDATION
       ================================================================ */
    if (placementToggle && placementWrapper) {
      placementToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (placementWrapper.hasAttribute('hidden')) {
          placementWrapper.removeAttribute('hidden');
          placementToggle.textContent = 'Hide custom spot';
          if (inputPlacement) inputPlacement.focus();
        } else {
          placementWrapper.setAttribute('hidden', '');
          placementToggle.textContent = 'Need a custom spot?';
          if (inputPlacement) inputPlacement.value = '';
        }
      });
    }

    /* ================================================================
       PLACEMENT TOGGLE & VALIDATION
       ================================================================ */
    function updatePlacementUI() {
      var selectedPlacement = document.querySelector('input[name="customizer-placement"]:checked');
      var placementVal = selectedPlacement ? selectedPlacement.value : 'Bottom Left Hem';

      // Update segmented control active states
      for (var p = 0; p < placementRadios.length; p++) {
        var radio = placementRadios[p];
        var label = document.getElementById('monogram-placement-label--' + radio.id.split('--')[1]);
        if (label) {
          if (radio.checked) {
            label.classList.add('is-active');
          } else {
            label.classList.remove('is-active');
          }
        }
      }

      if (placementVal === 'Back') {
        if (hintBack) hintBack.removeAttribute('hidden');
        if (hintDefault) hintDefault.setAttribute('hidden', '');
      } else {
        if (hintBack) hintBack.setAttribute('hidden', '');
        if (hintDefault) hintDefault.removeAttribute('hidden');
      }

      // Handle Background Image Swap
      if (mockupBg) {
        var isPink = mockupBg.src.indexOf('pink') !== -1;
        
        if (placementVal === 'Back') {
          mockupBg.src = isPink ? mockupBg.getAttribute('data-src-back-pink') : mockupBg.getAttribute('data-src-back-blue');
          if (mockupOverlay) mockupOverlay.classList.add('monogram-drawer__mockup-overlay--back');
        } else {
          mockupBg.src = isPink ? mockupBg.getAttribute('data-src-front-pink') : mockupBg.getAttribute('data-src-front-blue');
          if (mockupOverlay) mockupOverlay.classList.remove('monogram-drawer__mockup-overlay--back');
        }
      }
      
      updateLivePreview();
    }

    if (placementRadios) {
      for (var r = 0; r < placementRadios.length; r++) {
        placementRadios[r].addEventListener('change', updatePlacementUI);
      }
    }

    if (consentBox) {
      consentBox.addEventListener('change', validateForm);
    }

    /* ================================================================
       LIVE VECTOR PREVIEW CANVAS (Phase 3)
       ================================================================ */
    var colorHexMap = {
      'white': '#FFFFFF',
      'soft-pink': '#F4C2C2',
      'bright-pink': '#FF69B4',
      'red': '#CC3333',
      'green': '#719E52',
      'dark-green': '#355E3B',
      'light-blue': '#A8C4DC',
      'navy': '#005078'
    };

    function generateMonogramPreviewHTML(design, colorHex, colorHandle) {
      if (!design) return '';
      
      var imageDef = window.PuffinMonogramImages ? window.PuffinMonogramImages[design] : null;
      if (!imageDef) return '';

      if (imageDef.static && imageDef.mask) {
        var staticUrl = imageDef.static;
        var maskUrl = imageDef.mask;
        return '<div style="width:100%; height:100%; display:flex; align-items:center; justify-content:center; position:relative;">' +
               '<img src="' + staticUrl + '" style="position:absolute; width:100%; height:100%; object-fit:contain;" />' +
               '<div style="position:absolute; width:100%; height:100%; background:' + colorHex + '; ' +
               '-webkit-mask-image: url(' + maskUrl + '); -webkit-mask-size: contain; -webkit-mask-position: center; -webkit-mask-repeat: no-repeat; ' +
               'mask-image: url(' + maskUrl + '); mask-size: contain; mask-position: center; mask-repeat: no-repeat;"></div></div>';
      } else if (imageDef.mask) {
        var maskUrl = imageDef.mask;
        return '<div style="width:100%; height:100%; display:flex; align-items:center; justify-content:center;">' +
               '<div style="width:100%; height:100%; background:' + colorHex + '; ' +
               '-webkit-mask-image: url(' + maskUrl + '); -webkit-mask-size: contain; -webkit-mask-position: center; -webkit-mask-repeat: no-repeat; ' +
               'mask-image: url(' + maskUrl + '); mask-size: contain; mask-position: center; mask-repeat: no-repeat;"></div></div>';
      } else {
        var imgUrl = imageDef[colorHandle];
        if (!imgUrl) return '';
        return '<div style="width:100%; height:100%; display:flex; align-items:center; justify-content:center;">' +
               '<img src="' + imgUrl + '" style="max-width:100%; max-height:100%; object-fit:contain;" /></div>';
      }
    }

    function updateLivePreview() {
      var activePreviewNodes = document.querySelectorAll('[data-monogram-preview-overlay-node]');
      if (!activePreviewNodes.length) return;

      // Get selected color hex
      var checkedThread = document.querySelector('input[name="customizer-thread"]:checked');
      var threadHandle = checkedThread ? checkedThread.getAttribute('data-thread-color') : 'navy';
      var hex = colorHexMap[threadHandle] || '#13294B';

      var previewHTML = selectedDesign ? generateMonogramPreviewHTML(selectedDesign, hex, threadHandle) : '';

      for (var i = 0; i < activePreviewNodes.length; i++) {
        var node = activePreviewNodes[i];
        var placeholder = node.parentElement ? node.parentElement.querySelector('[data-monogram-preview-placeholder]') : null;

        if (previewHTML) {
          node.innerHTML = previewHTML;
          node.style.display = 'block';
          if (placeholder) placeholder.style.display = 'none';
        } else {
          node.innerHTML = '';
          node.style.display = 'none';
          if (placeholder) placeholder.style.display = 'block';
        }
      }
    }

    function validateForm() {
      if (!submitBtn) return;

      var hasText = false;
      if (activeTab === 'initials' && inputText) {
        hasText = inputText.value.trim().length > 0;
      } else if (activeTab === 'names' && inputName) {
        hasText = inputName.value.trim().length > 0;
      }

      var hasDesign = selectedDesign !== null;
      var hasThread = document.querySelector('input[name="customizer-thread"]:checked') !== null;
      var hasConsent = consentBox ? consentBox.checked : false;

      if (hasText && hasDesign && hasThread && hasConsent) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', '');
      }
    }

    /* Auto-select first design on open (Initials pane) */
    var paneInitials = document.getElementById('monogram-pane--initials');
    if (paneInitials) {
      var firstDesignRadio = paneInitials.querySelector('input[name="customizer-design"]');
      if (firstDesignRadio) {
        firstDesignRadio.checked = true;
        selectedDesign = firstDesignRadio.value;
      }
    }

    /* Initial state: ensure submit is disabled and colors are filtered */
    var activePreviewNodes = document.querySelectorAll('[data-monogram-preview-overlay-node]');
    for (var p = 0; p < activePreviewNodes.length; p++) {
      activePreviewNodes[p].style.display = 'none';
    }
    updateAvailableColors(selectedDesign);
    validateForm();
    updateLivePreview();

    /* Handle AJAX Cart Bundle Injection */
    if (submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Prevent multiple clicks
        if (submitBtn.hasAttribute('disabled')) return;
        submitBtn.setAttribute('disabled', 'disabled');
        var originalText = submitBtn.textContent;
        submitBtn.textContent = 'Saving...';

        // 2. Scrape drawer selections
        var activeTabEl = document.querySelector('.monogram-tab__btn.is-active');
        var activeTab = activeTabEl ? activeTabEl.getAttribute('id').replace('monogram-tab--', '') : 'initials';
        
        var inputTextEl = document.getElementById('monogram-input--text');
        var inputNameEl = document.getElementById('monogram-input--name');
        
        var textValue = '';
        if (activeTab === 'initials' && inputTextEl) {
          textValue = inputTextEl.value;
        } else if (activeTab === 'names' && inputNameEl) {
          textValue = inputNameEl.value;
        }

        var checkedPlacementEl = document.querySelector('input[name="customizer-placement"]:checked');
        var placementChoice = checkedPlacementEl ? checkedPlacementEl.value : 'Bottom Left Hem';
        var customPlacementEl = document.getElementById('monogram-input--placement');
        var placementWrapperEl = document.getElementById('monogram-placement-wrapper');
        
        var placementValue = placementChoice;
        if (placementWrapperEl && !placementWrapperEl.hasAttribute('hidden') && customPlacementEl && customPlacementEl.value.trim() !== '') {
          placementValue = "Custom: " + customPlacementEl.value.trim();
        }
        
        var checkedThreadEl = document.querySelector('input[name="customizer-thread"]:checked');
        var threadValue = checkedThreadEl ? checkedThreadEl.value : '';

        var checkedDesignEl = document.querySelector('input[name="customizer-design"]:checked');
        var designValue = checkedDesignEl ? checkedDesignEl.value : '';

        // 3. Build payload
        var coatProperties = {};
        if (textValue) {
          coatProperties[activeTab === 'initials' ? "Monogram Text" : "Monogram Name"] = textValue;
        }
        if (threadValue) {
          coatProperties["Thread Color"] = threadValue;
        }
        if (designValue) {
          coatProperties["Design Style"] = designValue;
        }
        if (placementValue) {
          coatProperties["Custom Placement"] = placementValue;
        }
        
        var consentBox = document.getElementById('monogram-checkbox--consent');
        if (consentBox && consentBox.checked) {
          coatProperties["Spelling Confirmed"] = "Yes";
        }
        
        // 4. Update Main Product Form Properties
        var propertiesContainer = document.getElementById('monogram-hidden-properties');
        if (propertiesContainer) {
          propertiesContainer.innerHTML = ''; // clear old
          
          for (var key in coatProperties) {
            if (coatProperties.hasOwnProperty(key)) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'properties[' + key + ']';
              input.value = coatProperties[key];
              propertiesContainer.appendChild(input);
            }
          }
        }
        
        // Update main form variant to "With Monogramming" safely
        var coatVariantId = null;
        var mapEl = document.getElementById('puffin-variant-map');
        if (mapEl) {
          try {
            var variantsMap = JSON.parse(mapEl.innerHTML);
            for (var title in variantsMap) {
              if (title.toLowerCase().indexOf('with monogramming') !== -1) {
                coatVariantId = variantsMap[title];
                break;
              }
            }
          } catch(e) {}
        }
        
        var coatVariantInput = document.querySelector('input[name="id"]');
        if (coatVariantInput && coatVariantId) {
          coatVariantInput.value = coatVariantId;
          // Dispatch input event so Alpine's x-model updates without triggering a section reload
          coatVariantInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Update UI
        var personalizeBtnText = document.querySelector('.monogram-cta__personalize-text');
        var personalizeBadge = document.getElementById('monogram-cta-badge');
        var clearBtn = document.getElementById('monogram-cta--clear');
        
        if (personalizeBtnText) personalizeBtnText.textContent = 'Edit Personalization';
        if (personalizeBadge) personalizeBadge.style.display = 'none'; 
        if (clearBtn) clearBtn.style.display = 'block';

        // Success: Close Drawer
        submitBtn.removeAttribute('disabled');
        submitBtn.textContent = 'Confirm Personalization';

        var closeBtn = document.getElementById('monogram-drawer-close');
        if (closeBtn) closeBtn.click();
      });
    }

    /* Clear Personalization Logic */
    var clearBtn = document.getElementById('monogram-cta--clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Clear properties
        var propertiesContainer = document.getElementById('monogram-hidden-properties');
        if (propertiesContainer) propertiesContainer.innerHTML = '';
        
        // Reset variant safely to "No Monogramming"
        var noMonogramId = null;
        var mapEl = document.getElementById('puffin-variant-map');
        if (mapEl) {
          try {
            var variantsMap = JSON.parse(mapEl.innerHTML);
            for (var title in variantsMap) {
              if (title.toLowerCase().indexOf('no monogramming') !== -1) {
                noMonogramId = variantsMap[title];
                break;
              }
            }
          } catch(e) {}
        }
        
        var coatVariantInput = document.querySelector('input[name="id"]');
        if (coatVariantInput && noMonogramId) {
          coatVariantInput.value = noMonogramId;
          coatVariantInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        
        // Reset UI
        var personalizeBtnText = document.querySelector('.monogram-cta__personalize-text');
        var personalizeBadge = document.getElementById('monogram-cta-badge');
        
        if (personalizeBtnText) personalizeBtnText.textContent = 'Personalize It';
        if (personalizeBadge) personalizeBadge.style.display = 'inline-block';
        clearBtn.style.display = 'none';

        // Reset drawer form inputs
        if (inputText) inputText.value = '';
        if (inputName) inputName.value = '';
        if (inputPlacement) inputPlacement.value = '';
        if (consentBox) consentBox.checked = false;
        
        // Reset to initials tab to clear state
        var tabInitialsBtn = document.getElementById('monogram-tab--initials');
        if (tabInitialsBtn) tabInitialsBtn.click();
      });
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMonogramTrigger();
      initMonogramControls();
    });
  } else {
    initMonogramTrigger();
    initMonogramControls();
  }

  // Re-initialize on Shopify Theme Editor section reload
  document.addEventListener('shopify:section:load', function() {
    initMonogramTrigger();
    initMonogramControls();
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
